import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import enNavbar from "./locales/en-US/navbar.json";
import enTable from "./locales/en-US/table.json";
import enCommon from "./locales/en-US/common.json";

import ptNavbar from "./locales/pt-BR/navbar.json";
import ptTable from "./locales/pt-BR/table.json";
import ptCommon from "./locales/pt-BR/common.json";

import esNavbar from "./locales/es-ES/navbar.json";
import esTable from "./locales/es-ES/table.json";
import esCommon from "./locales/es-ES/common.json";

import frNavbar from "./locales/fr-FR/navbar.json";
import frTable from "./locales/fr-FR/table.json";
import frCommon from "./locales/fr-FR/common.json";

i18n.use(initReactI18next).init({
  resources: {
    "en-US": { navbar: enNavbar, table: enTable, common: enCommon },
    "pt-BR": { navbar: ptNavbar, table: ptTable, common: ptCommon },
    "es-ES": { navbar: esNavbar, table: esTable, common: esCommon },
    "fr-FR": { navbar: frNavbar, table: frTable, common: frCommon },
  },
  lng: "en-US",
  fallbackLng: "en-US",
  ns: ["navbar", "table", "common"],
  defaultNS: "common",
  interpolation: { escapeValue: false }
});

export default i18n;
